export const IS_IE =
  typeof window !== "undefined" &&
  !!window.MSInputMethodContext &&
  !!(document as any).documentMode;

export const IS_PRODUCTION = process.env.NODE_ENV === "production";
export const ENABLE_LOGGING = typeof window !== "undefined" && !IS_PRODUCTION;

export const STATE_KEY = "tokyogreenv1";
